import { CircleHelp, X } from 'lucide-react'
import { useState } from 'react'
import { FaDiscord } from 'react-icons/fa'
import { DISCORD_INVITE_URL } from '@/components/auth/JoinDiscordSection'
import { LocalStorageKeys } from '@/constants/localstorage'
import { isBondTraderAppCompany } from '@/utils/appBranding'

function getStoredDismissal() {
  if (typeof window === 'undefined') return false

  try {
    return (
      window.localStorage.getItem(LocalStorageKeys.BONDTRADER_PROMO_BANNER_DISMISSED) === 'true'
    )
  } catch {
    return false
  }
}

function BondTraderMark() {
  return (
    <span
      className="relative inline-flex size-8 shrink-0 items-center justify-center"
      aria-hidden="true"
    >
      <svg viewBox="0 0 32 32" className="size-8 text-[#3b82f6]">
        <polygon points="16,2 28,9 28,23 16,30 4,23 4,9" fill="currentColor" />
      </svg>
      <span className="absolute text-[11px] font-extrabold leading-none text-white">B</span>
    </span>
  )
}

function BondTraderPromoBanner() {
  const [isDismissed, setIsDismissed] = useState(getStoredDismissal)

  if (!isBondTraderAppCompany() || isDismissed) {
    return null
  }

  function handleDismiss() {
    try {
      window.localStorage.setItem(LocalStorageKeys.BONDTRADER_PROMO_BANNER_DISMISSED, 'true')
    } catch {
      // no-op
    }
    setIsDismissed(true)
  }

  return (
    <section
      className="relative w-full shrink-0 border-y border-[#3b82f6]/70 bg-[#07111f] px-4 py-3 shadow-[0_0_24px_rgba(59,130,246,0.18)] sm:px-5"
      role="region"
      aria-label="BondTrader community"
    >
      <div className="flex flex-col gap-3 xl:flex-row xl:items-center xl:gap-5">
        <div className="flex min-w-0 flex-1 items-start gap-3 sm:items-center sm:gap-4">
          <div className="flex shrink-0 items-center gap-2">
            <BondTraderMark />
            <span className="text-sm font-semibold text-white">BondTrader.io</span>
          </div>

          <span className="hidden h-8 w-px shrink-0 bg-[#3b82f6]/40 sm:block" aria-hidden="true" />

          <div className="min-w-0 flex-1">
            <p className="text-sm leading-5 sm:text-[15px]">
              <span className="font-bold text-white">Welcome to BondTrader Challenges</span>{' '}
              <span className="font-semibold text-[#34d399]">Status: LIVE</span>
            </p>
            <p className="mt-1 max-w-3xl text-[13px] leading-5 text-[#c8d3e0]">
              Joining a challenge? Join Discord to complete onboarding and get support.
            </p>
          </div>
        </div>

        <div className="flex shrink-0 flex-wrap items-center gap-x-4 gap-y-2">
          <a
            href={DISCORD_INVITE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-xs font-medium text-[#93c5fd] no-underline transition-colors hover:text-white"
          >
            <CircleHelp className="size-3.5" aria-hidden="true" />
            Questions? Open a ticket in Discord.
          </a>
          <a
            href={DISCORD_INVITE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex h-9 items-center justify-center gap-2 rounded-md bg-[#2563eb] px-4 text-sm font-semibold text-white no-underline transition-colors hover:bg-[#1d4ed8]"
          >
            <FaDiscord className="size-4" aria-hidden="true" />
            Join Discord
          </a>
          <button
            type="button"
            onClick={handleDismiss}
            className="flex size-8 shrink-0 items-center justify-center rounded border border-white/50 bg-white/10 text-white transition-colors hover:bg-white/20"
            aria-label="Dismiss BondTrader community banner"
            title="Dismiss notice"
          >
            <X className="size-4" strokeWidth={2.5} />
          </button>
        </div>
      </div>
    </section>
  )
}

export default BondTraderPromoBanner
